import { render } from "./AuthorHero.vue?vue&type=template&id=7e01bcd4"
import script from "./AuthorHero.vue?vue&type=script&lang=js"
export * from "./AuthorHero.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\market\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__